module.exports = __webpack_public_path__ + "static/media/1.09def33e.png";